import { render } from "./ConnectFlowPage.vue?vue&type=template&id=523b01ee&ts=true"
import script from "./ConnectFlowPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectFlowPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/ConnectFlowPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "523b01ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('523b01ee', __exports__)) {
    api.reload('523b01ee', __exports__)
  }
  
  module.hot.accept("./ConnectFlowPage.vue?vue&type=template&id=523b01ee&ts=true", () => {
    api.rerender('523b01ee', render)
  })

}


export default __exports__